// extracted by mini-css-extract-plugin
export default {"sbomPolicyHeading":"_91IQ8QiXpxlBB9Nw9JrV"};